import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "QuestionName",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "QuestionOptionName",
    isNumber: true,
  },
];

export const CheckAreaToExplainResult = {
  label: "篩檢場域 VS 判讀結果",
  key: "CheckAreaToExplainResult",
  path: "FundusAbnormal/CheckAreaToExplainResult",
  api: "TCS_V_EyesS02",
  render: (options) => (
    <Diagram.FundusAbnormal.CheckAreaToExplainResult {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "Q2649",
      field: "Q2649",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
